import { Accordion } from './Accordion';
import { ContactForm } from './ContactForm';
import { FlipTile } from './FlipTile';
import { NavToggle } from './NavToggle';
import { NumberCounter } from './NumberCounter';
import { QuizForm } from './QuizForm';
import { ScrollTo } from './ScrollTo';
import { SmartHeader } from './SmartHeader';
import { StickySection } from './StickySection';
import { StripesAnimation } from './StripesAnimation';
import { SwipeCard } from './SwipeCard';
import { ThanksMessage } from './ThanksMessage';

const components = [Accordion, ContactForm, FlipTile, NavToggle, NumberCounter, QuizForm, ScrollTo, SmartHeader, StickySection, StripesAnimation, SwipeCard, ThanksMessage];

export default components;
